<template>
    
    <div class="section" v-if="summary.labels && user_level !== 3" v-html="summary.labels">

    </div>

    <div class="section pt-0 mt-0">
        <div class="listed-detail">
            <h3 class="text-center mt-2 custom-title">{{ pageTitle }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0" v-if="!loading_list && member_lists.length <= 0">{{ noDataMessage }}</h4>
    </div>

    <!-- Members Report Table -->
        <!-- Election Status Totals Card -->
        <div class="section mb-2" v-if="!loading_list && member_lists.length > 0 && user_level !== 3">
            <div class="card stat-box d-flex flex-row justify-content-around align-items-center p-2" style="gap: 10px;">
                <div>
                    <div class="title">NS</div>
                    <div class="value text-secondary">{{ totalNS }}</div>
                </div>
                <div>
                    <div class="title">SCH</div>
                    <div class="value text-primary">{{ totalSCH }}</div>
                </div>
                <div>
                    <div class="title">RS</div>
                    <div class="value text-warning">{{ totalRS }}</div>
                </div>
                <div>
                    <div class="title">RA</div>
                    <div class="value text-success">{{ totalRA }}</div>
                </div>
                <div>
                    <div class="title">RR</div>
                    <div class="value text-danger">{{ totalRR }}</div>
                </div>
            </div>
        </div>

        <div class="section mt-2 mb-2" v-if="!loading_list && member_lists.length > 0">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">{{ levelName }}</th>
                            <th scope="col" class="text-center" v-if="user_level === 3">Election Status</th>
                            <th scope="col" v-if="user_level !== 3">NS</th>
                            <th scope="col" v-if="user_level !== 3">SCH</th>
                            <th scope="col" v-if="user_level !== 3">RS</th>
                            <th scope="col" v-if="user_level !== 3">RA</th>
                            <th scope="col" v-if="user_level !== 3">RR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in member_lists" :key="item.id">
                            <td class="text-primary font-dark text-left" v-if="user_level <= 2">
                                <router-link :to="'/reports/'+(user_level+1)+'/'+item.id+'/unit-election-report'">
                                    <strong>{{ item.name }}</strong>
                                </router-link>
                            </td>
                            <td class="text-primary font-dark text-left" v-if="user_level == 3">
                                <router-link :to="'/org/4/'+item.id+'/members-list'">
                                    <strong>{{ item.name }}</strong>
                                </router-link>
                            </td>
                            
                            <!-- Election Status and Title columns (only for zone level) -->
                            <td class="font-dark small-text" style="text-align: center !important;" v-if="user_level === 3" :class="getElectionStatusColor(item.election_status)">
                                <div style="text-align: center !important;" v-html="item.election_status || '-'"></div>
                            </td>
                            
                            <!-- Regular report columns (not for zone level) -->
                            <td class="text-secondary font-dark small-text" v-if="user_level !== 3" v-html="item.not_scheduled"></td>
                            <td class="text-primary font-dark small-text" v-if="user_level !== 3" v-html="item.scheduled"></td>
                            <td class="text-warning font-dark small-text" v-if="user_level !== 3" v-html="item.report_sent"></td>
                            <td class="text-success font-dark small-text" v-if="user_level !== 3" v-html="item.report_accepted"></td>
                            <td class="text-danger font-dark small-text" v-if="user_level !== 3" v-html="item.report_rejected"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "../../services/user.service";

export default {
    name: 'MembersListReport',
    data() {
        return {
            permissions:[],
            loading_list: false,
            user_level: 1,
            user_level_id: null,
            member_lists: [],
            summary: {
                wisdom: '0 / 0 / 0',
                youth: '0 / 0 / 0',
                students: '0 / 0 / 0',
                women: '0 / 0 / 0',
                girls: '0 / 0 / 0',
                balavedi: '0 / 0 / 0'
            },
            series: [0, 0, 0, 0, 0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6c757d'],
                labels: ['Wisdom', 'Youth', 'Students', 'Women', 'Girls', 'Balavedi'],
                legend: {
                    position: 'bottom'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 300
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            }
        };
    },
    computed: {
            // Totals for NS, SCH, RS, RA, RR
            totalNS() {
                return this.member_lists.reduce((sum, item) => sum + (parseInt(item.not_scheduled) || 0), 0);
            },
            totalSCH() {
                return this.member_lists.reduce((sum, item) => sum + (parseInt(item.scheduled) || 0), 0);
            },
            totalRS() {
                return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_sent) || 0), 0);
            },
            totalRA() {
                return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_accepted) || 0), 0);
            },
            totalRR() {
                return this.member_lists.reduce((sum, item) => sum + (parseInt(item.report_rejected) || 0), 0);
            },
        currentUser() {
            return this.$store.state.auth.user;
        },
        totalMembersCount() {
            // Extract total counts from summary for pie chart
            let total = 0;
            Object.values(this.summary).forEach(value => {
                if (typeof value === 'string') {
                    const parts = value.split(' / ');
                    if (parts.length > 1) {
                        total += parseInt(parts[0]) || 0; // Get the total count (third value)
                    }
                }
            });
            return total;
        },
        levelName() {
            if (this.user_level === 1) return 'District';
            if (this.user_level === 2) return 'Zone';
            if (this.user_level === 3) return 'Unit';
            return 'Level';
        },
        pageTitle() {
            if (this.user_level === 1) return 'State - District wise Election Report';
            if (this.user_level === 2) return 'District - Zone wise Election Report';
            if (this.user_level === 3) return 'Zone - Unit wise Election Report';
            return 'Election Report';
        },
        noDataMessage() {
            if (this.user_level === 1) return 'No districts found';
            if (this.user_level === 2) return 'No zones found';
            if (this.user_level === 3) return 'No units found';
            return 'No data found';
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level) || 1;
            this.user_level_id = parseInt(this.$route.params.id) || null;
            this.getMembersListReport();
            this.$root.updateParent(this.$t('unit_election_report'));
        }
    },
    methods: {
        getElectionStatusColor(status) {
            if (!status) return '';
            
            const statusText = status.toLowerCase();
            
            if (statusText.includes('accepted') || statusText.includes('approved')) {
                return 'text-success'; // Green for accepted/approved
            } else if (statusText.includes('rejected') || statusText.includes('declined')) {
                return 'text-danger'; // Red for rejected/declined
            } else if (statusText.includes('not scheduled') || statusText.includes('not started')) {
                return 'text-secondary'; // Gray for not scheduled/not started
            } else if (statusText.includes('scheduled') || statusText.includes('planned')) {
                return 'text-primary'; // Blue for scheduled/planned
            } else if (statusText.includes('pending') || statusText.includes('sent')) {
                return 'text-warning'; // Orange for pending/sent
            }
            
            return 'text-dark'; // Default color
        },
        getMembersListReport() {
            this.loading_list = true;
            
            const data = {
                user_level: this.user_level,
                user_level_id: this.user_level_id,
                report_type: 'election'
            };

            UserService.authGetRequest('get-reports/unit-election-report', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.member_lists = response.data.data.list || [];
                        this.summary = response.data.data.summary || {};
                        this.permissions = response.data.data.permissions;
                        // Update chart after a small delay to ensure DOM is ready
                        this.$nextTick(() => {
                            this.updateChart();
                        });
                    } else {
                        console.error('API Error:', response.data.message);
                        this.showErrorMessage(response.data.message || 'Failed to load data');
                    }
                    this.loading_list = false;
                },
                (error) => {
                    this.loading_list = false;
                    console.error('Request Error:', error);
                    this.showErrorMessage(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        'Something went wrong while fetching data'
                    );
                }
            );
        },
        
        updateChart() {
            // Extract total counts from summary for pie chart
            const totals = {
                wisdom: this.extractTotalFromSummary(this.summary.wisdom),
                youth: this.extractTotalFromSummary(this.summary.youth),
                students: this.extractTotalFromSummary(this.summary.students),
                women: this.extractTotalFromSummary(this.summary.women),
                girls: this.extractTotalFromSummary(this.summary.girls),
                balavedi: this.extractTotalFromSummary(this.summary.balavedi)
            };

            this.series = [
                totals.wisdom,
                totals.youth,
                totals.students,
                totals.women,
                totals.girls,
                totals.balavedi
            ];
        },

        extractTotalFromSummary(summaryString) {
            if (typeof summaryString === 'string') {
                const parts = summaryString.split(' / ');
                if (parts.length === 3) {
                    return parseInt(parts[2]) || 0; // Get the total count (third value)
                }
            }
            return 0;
        },
        
        viewDetails(item) {
            if (this.user_level <= 2) {
                this.$router.push(`/org/${this.user_level + 1}/${item.id}/unit-election-report`);
            } else {
                // For unit level, navigate to members list or specific view
                this.$router.push(`/org/${this.user_level + 1}/${item.id}/members-list`);
            }
        },

        showErrorMessage(message) {
            // You can implement a toast notification or alert here
            if (this.$swal) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: message,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });
            } else {
                alert(message);
            }
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 10px;
    text-align: center;
}

.stat-box .title {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
    margin-bottom: 5px;
}

.stat-box .value {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 2px;
    line-height: 1.2;
}

.stat-box .subtitle {
    font-size: 9px;
    color: #999;
    margin-top: 2px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 20px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 16px;
    position: relative;
    z-index: 1;
    padding-bottom: 0px !important;
}

.custom-title {
    font-weight: 600;
    color: #27173E;
}

.font-dark {
    font-weight: 500;
}

.table th {
    font-size: 12px;
    text-align: center;
    background-color: #f8f9fa;
    font-weight: 600;
}

.table td {
    text-align: center;
    font-size: 12px;
    vertical-align: middle;
    padding: 8px 4px;
}

.table td.text-left {
    text-align: left;
}

.small-text {
    font-size: 10px;
    line-height: 1.2;
}

.small-text p {
    margin: 0;
    padding: 0;
}

.action-button-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.action-button-list li {
    margin-bottom: 10px;
}

.action-divider {
    height: 1px;
    background-color: #e9ecef;
    margin: 10px 0;
}

.btn-list {
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-list:hover {
    background-color: #f8f9fa;
}

.chart-container {
    position: relative;
    width: 100%;
    max-width: 400px;
}

.right .chart-container {
    width: 100%;
}

@media (max-width: 576px) {
    .stat-box .value {
        font-size: 12px;
    }
    
    .stat-box .subtitle {
        font-size: 8px;
    }
    
    .table th,
    .table td {
        font-size: 10px;
        padding: 6px 2px;
    }
    
    .small-text {
        font-size: 9px;
    }
    
    .wallet-card .balance {
        flex-direction: column;
        align-items: center;
    }
    
    .left {
        margin-left: 0;
        text-align: center;
        margin-bottom: 15px;
    }
    
    .chart-container {
        width: 100%;
        max-width: 300px;
    }
}

@media (max-width: 768px) {
    .table-responsive {
        font-size: 10px;
    }
    
    .table th,
    .table td {
        padding: 6px 3px;
    }
}
</style>